<template>
  <svg
    width="41"
    height="41"
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.9126 2.7829C22.6016 -0.0387366 17.7318 -0.0387366 14.4207 2.7829C13.5891 3.49157 12.5552 3.91984 11.4661 4.00676C7.12963 4.35281 3.68614 7.7963 3.34008 12.1327C3.25317 13.2219 2.8249 14.2558 2.11623 15.0874C-0.705408 18.3984 -0.705408 23.2683 2.11623 26.5793C2.8249 27.4109 3.25317 28.4448 3.34008 29.5339C3.68614 33.8704 7.12963 37.3139 11.4661 37.6599C12.5552 37.7468 13.5891 38.1751 14.4207 38.8838C17.7318 41.7054 22.6016 41.7054 25.9126 38.8838C26.7442 38.1751 27.7781 37.7468 28.8673 37.6599C33.2037 37.3139 36.6472 33.8704 36.9932 29.5339C37.0802 28.4448 37.5084 27.4109 38.2171 26.5793C41.0387 23.2683 41.0387 18.3984 38.2171 15.0874C37.5084 14.2558 37.0802 13.2219 36.9932 12.1327C36.6472 7.7963 33.2037 4.35281 28.8673 4.00676C27.7781 3.91984 26.7442 3.49157 25.9126 2.7829ZM27.8797 17.5464C28.5957 16.8304 28.5957 15.6696 27.8797 14.9536C27.1637 14.2377 26.0029 14.2377 25.287 14.9536L18.3333 21.9073L15.963 19.537C15.2471 18.821 14.0863 18.821 13.3703 19.537C12.6543 20.2529 12.6543 21.4137 13.3703 22.1297L17.037 25.7964C17.7529 26.5123 18.9137 26.5123 19.6297 25.7964L27.8797 17.5464Z"
      fill="white"
    />
  </svg>
</template>
